import { render, staticRenderFns } from "./MemberData.vue?vue&type=template&id=f36c217e&scoped=true&"
import script from "./MemberData.vue?vue&type=script&lang=js&"
export * from "./MemberData.vue?vue&type=script&lang=js&"
import style0 from "./MemberData.vue?vue&type=style&index=0&id=f36c217e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36c217e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
